<template>
  <div class="input-label-content">
    <div
      v-if="input.inputSettings?.type === FieldInputType.Checkbox"
      :class="['input-label']"
    ></div>
    <ProsemirrorViewerFormInput
      v-else
      :class="['input-label', { 'is-required': input.inputSettings?.required && editable }]"
      data-external="form-input-text-label-view"
      :content="ProsemirrorHelper.getSafeText(input.inputSettings?.richTextLabel)"
      :merge-values="mergeValues"
      :fields="fields"
      :multi-line="false"
      :label="false"
      :link="false"
      placeholder=""
    />
  </div>
</template>
<script setup lang="ts">
import type { Field, MergeValues } from '@getaccept/editor-lib';
import { FieldInputType, ProsemirrorHelper } from '@getaccept/editor-lib';
import ProsemirrorViewerFormInput from './ProsemirrorViewerFormInput.vue';

const { fields = [] } = defineProps<{
  input: Field;
  mergeValues: MergeValues;
  fields?: Field[];
  editable?: boolean;
}>();
</script>
<style lang="scss" scoped>
@import '@getaccept/editor-lib/src/scss/input-set';
</style>
